<template>
    <div>
        <base-crud
                crudName="Turnos"
                newText="Novo Turno"
                :table="shiftTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="true"
                :enableEdit="true"
                :enableDelete="true"
                :enableView="false"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'

    export default {
        data: function () {
            return {
                shiftTable: 'shiftTable',
                shifts: [],
                pages: [],
                url: '',
                columns: ['id', 'name', 'initial_hour', 'final_hour','actions'],
                tableData: ['id', 'name','initial_hour', 'final_hour'],
                options: {
                    filterable:["id", "name", "initial_hour", "final_hour"],
                    filterByColumn: true,                   
                    sortable: ['id', 'name', 'initial_hour', 'final_hour'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll'},
                    perPage: 10,
                    perPageValues: [10,25,50,100],
                    headings: {
                        'id': 'ID',
                        'name' : 'Nome',
                        'initial_hour': 'Hora Inicial',
                        'final_hour': 'Hora Final',
                        'actions' : 'Ações'
                    },
                    requestFunction: function(data) {
                      let requestData = {};

                       let query = this.$parent.$parent.query(data.query);
                       requestData.params = data;
                       requestData.params.query = "";
                       requestData.params.with = [];

                      return this.$http
                          .get(this.url + '?' + query, requestData)
                          .catch(
                              function(e) {
                                  this.dispatch("error", e);
                              }.bind(this)
                          );
                    }
                },
                endPoint: 'shifts/'
            }
        },
        methods: {
          query: function (query) {
            let columns = {
              id: 'id',
              name: 'name',
              initial_hour: 'initial_hour',
              final_hour: 'final_hour',
            };
            let filters = "";
            $.each(query, function (index, value) {
              filters += columns[index] + "=" + value + "&";
            });

            return filters;
          }
        },
        components: {
            BaseCrud
        }
    }
</script>

<style scoped>
    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Shift/Crud.vue